var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Price_Tag",
    "data-name": "Price Tag",
    transform: "translate(-1214 -601)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19349",
    "data-name": "Rectangle 19349",
    width: 40,
    height: 40,
    transform: "translate(1214 601)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-price-tag-4525318",
    d: "M139.8,63.982a3.581,3.581,0,0,0-3.116-1.011l-4.851.765a3.589,3.589,0,0,0-1.99,1.011l-6.483,6.484a2.888,2.888,0,0,0,0,4.084l5.105,5.105a2.888,2.888,0,0,0,4.084,0l6.484-6.483a3.588,3.588,0,0,0,1.011-1.99l.765-4.851h0a3.574,3.574,0,0,0-1.01-3.115Zm-3.676,6.739h0a2.166,2.166,0,1,1-3.064-3.064,2.218,2.218,0,0,1,3.064,0,2.166,2.166,0,0,1,0,3.064Z",
    transform: "translate(1102.317 548.905)",
    fill: "#527e3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/Price Tag.0781da63936e9b40f840dd6c667ca87c.svg";
export { ForwardRef as ReactComponent };